export enum SignState {
  verifyPassword = 'verifyPassword',
  openMaiDan = 'openMaiDan',
  callWXScore = 'callWXScore',
  popAuthModal = 'popAuthModal',
  smsVerify = 'smsVerify',
  noNeedVerify = 'noNeedVerify',
}
export enum SignStatusType {
  Start = 'start',
  Success = 'success',
  Fail = 'fail',
}
export enum QueryStatusType {
  Fail,
  Success,
  Querying,
}
export enum QueryOrderStatus {
  success = 'success', // 订单支付成功
  fail = 'fail', // 订单支付失败
  outstanding = 'new', // 订单未支付
  creditsuccess = 'credit_success', // 微信分赊销成功
}

export enum PayResult {
  success = 'success', // 支付成功
  fail = 'fail', // 支付失败
  cancel = 'cancel', // 支付取消
}

export enum VisiblePage {
  index = 'BackIndex',
  agreement = 'openAgreement',
  order = 'openOrder',
  summary = 'showSummary',
  record = 'showRecords',
  promo = 'showPromo',
  instruction = 'showInstruction',
}

export enum PageType {
  index = 'index',
  home = 'home',
  payment = 'payment',
  paydelay = 'paydelay',
}

export enum Runtime {
  Prod,
  Staging,
  Test,
  Dev,
  Local,
}

export enum OpenType {
  IndependenceSign, // 独立签约
  InpaySign, // 支付流程签约
}

export enum PayFailAction {
  guideFinish = 'guide_finish',
  guidePayment = 'guide_payment',
}

export enum CallbackPayResultSource {
  bridgeCouponDialogSuccess = 'bridgeCouponDialogSuccess',
  bridgeCouponDialogFail = 'bridgeCouponDialogFail',
  appearCouponDialog = 'appearCouponDialog',
  nonShowCouponDialog = 'nonShowCouponDialog',
  independenceResultFail = 'independenceResultFail',
  inPayFail = 'inPayFail',
  inPaySuccess = 'inPaySuccess',
}

export enum NextStep {
  RealName = 1, // 实名认证
  PassVerify, // 差异化验证，独立验证
  Credit, // 授信
}

export enum CheckResult {
  Success = 1,
  Fail,
}

export enum ReversionId {
  Init = 1,
  ImproveCTR,
  PreorderAccessModel, // 新聚合先用后付前置流程
  PayDelayIndependenceSign, // 新聚合先用后付独立流程
}

export enum AccessSource {
  WebCashier = 'web-cashier',
}

// 常量
export const PAY_TOKEN = 'payToken';
export const PAY_RESULT_FOR_DEFER = 'PAY_RESULT_FOR_DEFER';
export const metricPoints = {
  showIndexPage: 'show_index_page',
  tradeStatus: 'trade_status',
  showSummaryPage: 'show_summary_page',
  showRecordsPage: 'show_records_page',
  showIntroductionPage: 'show_introduction_page',
  signedSuccess: 'signed_success',
  signedStatus: 'signed_status',
  bridgeStart: 'custombridgeStart',
  bridgeSuccess: 'custombridgeSuccess',
  bridgeFail: 'custombridgeFail',
  paySelectBank: 'paySelectBank',
  clickPayButton: 'click_pay_button', // 支付按钮
  NSFIsUse: 'nsf_is_use', // NSF 最终是否使用
  enableNSF: 'enable_nsf', // 是否能使用 NSF
  pageStart: 'page_start', // 页面起始
  pageShowStatus: 'page_show_status', // 页面签约状态，签约微信分或先用后付，已开通或是未开通
};
// 独立签约使用类型
export enum CreditType {
  WeiXin = 'wxscore',
  PayDefer = 'paydefer',
  PayDelay = 'delaypay',
}
// 支付流程使用类型
export enum PayType {
  WeiXin = 'wxcreditauth',
  PayDelay = 'delaypay',
}
// 结果页数据
export enum NoemaType {
  Notify,
  Coupon,
  Gift,
  Edu,
}
export enum ResultAdxMetricPoints {
  AdxShow = 'adx_show',
  AdxError = 'adx_error',
}
// 美团支付桥 action
export enum SelectBankAction {
  StartGoHelloPay = 'start_go_hello_pay', // 美团支付
}
export enum PayResultStatus {
  PAY_SUCCESS = 'pay_success', // 支付结果页
  PAY_CANCEL = 'pay_cancel', // 取消支付
  PAY_FAIL = 'pay_fail', // 类似 level:2 退美团支付
  PAY_OVERTIME = 'pay_overtime', // 类似 level:4 超时
  PAY_FATAL_ERROR = 'pay_fatal_error', // 调桥参数不合适，刷新收银台,level: 6
  FATAL_ERROR = 'fatal_error', // 调桥参数不合适，刷新收银台,level: 6
  NATIVE_EXCEPTION = 'native_exception', // native 各类未知异常
  PAY_EXCEPTION = 'pay_exception', // gohellopay 接口标准报错
  GO_HELLO_PAY_OVERLOAD = 'go_hello_pay_overload', // gohellopay 接口过载
  SELECT_BANK_CLOSE = 'select_bank_close', // 关闭切卡弹窗
  ERROR = 'error', // 桥的错误信息，或者异常
}
interface PayResultOverlaod {
  status: PayResultStatus.GO_HELLO_PAY_OVERLOAD;
  data?: {
    status: boolean;
    timeout: number;
    message: string;
  };
}
export interface PayStatusParams {
  pay_result:
    | PayResultOverlaod
    | {
        status: Exclude<PayResultStatus, PayResultStatus.GO_HELLO_PAY_OVERLOAD>;
        data?: ErrorType | { data: ErrorType };
        promotion?: Record<string, unknown>;
      };
}
export enum CashierPayErrorType {
  // 支付操作节流
  PayThrottle = 'PayThrottle',
  // 支付服务过载
  PayOverload = 'PayOverload',
  // 美团支付取消，什么都不干
  MTPayCancel = 'MTPayCancel',
  // 美团支付 - 页面退出
  MTPayExit = 'MTPayExit',
  // 美团支付 - 页面刷新
  MTPayRefresh = 'MTPayRefresh',
  // 美团支付错误，展示 toast 提示
  MTPayError = 'MTPayError',
}
export interface CashierPayErrorData {
  [key: string]: any;
  // toast 文案
  message?: string;
  // 支付结果标识
  payResult?: string;
  // 重新请求订单数据标识
  requireGetOrderInfo?: boolean;
}
export class CashierPayError extends Error {
  name: string = 'CashierPayError';

  type: CashierPayErrorType;

  data: CashierPayErrorData = {};

  constructor(type: CashierPayErrorType, data: CashierPayErrorData, message: string) {
    super(message);
    this.type = type;
    this.data = data;
  }

  static isCashierPayError(error: any): error is CashierPayError {
    return error?.name === 'CashierPayError';
  }
}
export enum SceneType {
  Unopen = 1, // 引导
  Opened = 10,
}
export const RETRY_COUNT = 5; // 点击开启代扣循环 5 次，每 500ms 调用一次，考虑接口耗时按50ms，总体查询时长约 5s
export enum NativeBridgeErrorCode {
  Success = 10,
  Fail,
  Cancel,
}

export enum AccessStatusType {
  Access = 1,
  Unaccess = 2,
}

export enum SceneCode {
  MTMobike = 'MTMobike',
  MTTaxi = 'MTTaxi',
  TJTG = 'TJTG',
}
export enum ToastType {
  Loading = 'loading',
  Text = 'text',
  Error = 'error',
  Success = 'success',
  PayLogo = 'pay-logo',
}
export enum OpenStatus {
  Unopen = 'NOT_SIGNED', // 未开通
  Open = 'SIGNED', // 已开通
}
export enum SignErrorType {
  BridgeError,
  ApiError,
}
// 预请求接口
export enum NSFUrl {
  Index = '/paydefer/homepage',
  Paydelay = '/cashier/displayconsult',
}
// 营销页面所需的参数，目前前置没有接口承接，暂时这么写
export const promoDescriptions = [
  {
    title: '使用范围',
    content:
      '使用范围：商品带有先用后付标签，用户下单支付时，选择<span class="promo-color">先用后付</span>支付方式，即可享受立减优惠。',
  },
  {
    title: '优惠信息',
    content:
      '首次开通美团先用后付或者微信支付分｜先用后付，<span class="promo-color">可享先用后付支付首次立减优惠。</span>',
  },
  {
    title: '使用规则',
    content:
      '用户<span class="promo-color">首次开通</span>先用后付功能，并使用后付支付可享受立减优惠。</br>立减优惠使用时间：领取后<span class="promo-color">7天有效</span>。',
  },
];
